export default {"src":"/_next/static/media/star_pink.61c7ae5c.svg","height":19,"width":20,"blurWidth":0,"blurHeight":0};